import React from 'react'
import Image from '../Image'
import cn from 'classnames'

import st from './index.scss'

export default function GoodsImage({ src, srcMask, className, ...props }) {

    return <div className={cn(st['box'], className)} {...props}>
        <Image src={src} />
        {srcMask && <Image src={srcMask} className={st['mask']} />}
    </div>
}
